<template>
<div class="expire_file">
        <OtherHead :tipText="$t('没有访问权限')"></OtherHead>
        <div class="empty_content">
            <img src="@/assets/img/share/icon_apply_no_auth.png" alt=""/>
            <div class="empty_text">{{$t("链接已经过期")}}</div>
        </div>
    </div>
</template>

<script lang="ts">
import OtherHead from './OtherHead.vue'
export default {
    name: 'no_limit',
    components: {
        OtherHead
    },
    data() {
        return {

        }
    },
    computed: {

    },
    methods: {

    },
}
</script>

<style lang="scss" scoped>
.expire_file {
    flex: 1;
    display: flex;
    flex-direction: column;

    .empty_content {
        flex: 1;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;

        img {
            width: 127px;
        }

        .empty_text {
            margin-top: 16px;
            height: 20px;
            font-family: PingFangSC-Regular;
            font-weight: 400;
            font-size: 14px;
            color: #A2A4B0;
            text-align: center;
        }
    }
}
</style>
